import React from 'react';

interface ChartLegendData {
    newX?: number;
    newY?: number;
    currX?: number;
    currY?: number;
    newTriangle?: string;
    currTriangle?: string;
}

interface ChartLegendProps {
    data?: ChartLegendData;
    labelNew?: string;
    labelCurrent?: string;
}

const ChartLegend: React.FC<ChartLegendProps> = ({
    data = {},
    labelNew = '',
    labelCurrent = '',
}) => {
    return (
        <>
            <g>
                <polygon
                    points={data.currTriangle}
                    className="chart-triangle chart-color-1"
                />

                <text
                    x={data.currX}
                    y={data.currY}
                    fontSize="14px"
                    className="chart-legend"
                >
                    {labelCurrent}
                </text>
            </g>

            <g>
                <polygon
                    points={data.newTriangle}
                    className="chart-triangle chart-color-0"
                />

                <text
                    x={data.newX}
                    y={data.newY}
                    fontSize="14px"
                    className="chart-legend"
                >
                    {labelNew}
                </text>
            </g>
        </>
    );
};

export default ChartLegend;